import React, { Component } from 'react'
import { Card, CardBody } from 'reactstrap'
import TextArea from 'apa/components/TextArea'
import autobind from 'autobind-decorator'
import * as categories from 'catalog/actions/categories'
import {connect} from 'react-redux'

@connect(
    state => ({
        activeCategory: state.categories.activeCategory,
        activeSubcategory: state.categories.activeSubcategory
    }),
    dispatch => ({
        updateCategory: (category) => dispatch(categories.updateCategory(category)),
        updateSubcategory: (subcategory) => dispatch(categories.updateSubcategory(subcategory)),
    })
)
export default class CategoryResources extends Component {

    constructor(props) {
        super(props)
        const {activeCategory, activeSubcategory} = props
        this.state = {
            activeCategory,
            activeSubcategory
        }
    }
    @autobind
    changeCategoryResources(e) {
        const resources = e.target.value;
        const activeCategory = { ...this.props.activeCategory, resources: resources };
        this.setState({activeCategory})
    }

    @autobind
    changeSubcategoryResources(e) {
        const resources = e.target.value;
        const activeSubcategory = { ...this.props.activeSubcategory, resources: resources };
        this.setState({activeSubcategory})
    }

    @autobind
    updateCategory() {
        this.props.updateCategory(this.state.activeCategory);
    }

    @autobind
    updateSubcategory() {
        this.props.updateSubcategory(this.state.activeSubcategory);
    }


    render() {
        const {
            activeCategory,
            activeSubcategory
        } = this.state
        return (
            <Card>
                <CardBody>
                    <h5>Quellen <small>{this.props.activeCategory.name}</small></h5>
                    <TextArea value={activeCategory.resources} onChange={this.changeCategoryResources}
                        onBlur={this.updateCategory} />
                    <h5>Quellen <small>{this.props.activeSubcategory.name}</small></h5>
                    <TextArea value={activeSubcategory.resources}
                        onChange={this.changeSubcategoryResources}
                        onBlur={this.updateSubcategory} />
                </CardBody>
            </Card>
        )
    }
}